import { type FC } from 'react';
import type { LatestRealizedVolsProps } from './types';
import LatestRealizedVolsContent from './latest-realized-vols-content';
import { Widget } from '../../widget';
import WidgetButtons from '../../widget-buttons';

const LatestRealizedVolsWidget: FC<LatestRealizedVolsProps> = (props) => {
  const { widget, actions } = props;

  return (
    <Widget cardKey={widget.key}>
      <Widget.Header>
        <Widget.Title title={widget.title} />
        <Widget.Buttons>
          <WidgetButtons widget={widget} actions={actions} permissions={props.permissions} />
        </Widget.Buttons>
      </Widget.Header>
      <Widget.Content>
        <LatestRealizedVolsContent />
      </Widget.Content>
      <Widget.Footer />
    </Widget>
  );
};

export default LatestRealizedVolsWidget;
